// SiteUP CRM: regra de IA do Kanban da conta (GET kanban_ai_settings) lida uma
// vez por conta e compartilhada. O painel de contato monta de novo a cada
// conversa aberta e pedia a mesma configuração toda vez; quem abre várias
// conversas via o mesmo GET repetido. Pedidos ao mesmo tempo dividem a mesma
// promessa. Salvar o padrão da conta (KANBAN_AI_ACCOUNT_RULE_SAVED) limpa o
// cache: quem já está na tela atualiza pelo próprio evento e a próxima
// montagem lê de novo.
import KanbanAPI from 'dashboard/api/kanban';
import { emitter } from 'shared/helpers/mitt';
import { KANBAN_AI_ACCOUNT_RULE_SAVED } from './kanbanAiRule';

const cache = new Map();

export const clearAccountAiSettingsCache = () => cache.clear();

export const fetchAccountAiSettings = accountId => {
  const key = String(accountId ?? '');
  if (cache.has(key)) return cache.get(key);

  const promise = KanbanAPI.getGlobalAiSettings()
    .then(response => response?.data)
    .catch(error => {
      // Falha não fica guardada: a próxima montagem tenta de novo.
      if (cache.get(key) === promise) cache.delete(key);
      throw error;
    });
  cache.set(key, promise);
  return promise;
};

emitter.on(KANBAN_AI_ACCOUNT_RULE_SAVED, clearAccountAiSettingsCache);
